// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__hHv0U","footer":"ModalUpdate_footer__2ljbb"};